import { ReactNode, useState } from 'react';

import { CopyIcon } from '../../../../../assets/svg';
import {
	Button,
	TransferData,
	TransferDetail,
	TransferDetailContainer,
	TransferItem,
} from './styles';

interface TransferResume {
	item: string | ReactNode;
	data: string | number;
	copy?: boolean;
	value: string | number;
}

interface RefundResume {
	transferResume: TransferResume[];
}

const RefundResume = ({ transferResume }: RefundResume) => {
	const [colorClick, setColorClick] = useState<Record<string, string>>({}); // Manejo del estado individual por ícono

	const handleCopyToClipboard = async (id: string | number, text: string | number) => {
		setColorClick((prev) => ({ ...prev, [id]: '#140F33' }));
		navigator.clipboard.writeText(text.toString());

		setTimeout(() => {
			setColorClick((prev) => ({ ...prev, [id]: '#646174' }));
		}, 200);
	};

	return (
		<TransferDetail>
			{transferResume.map(({ item, data, copy, value }: TransferResume, index) => (
				<TransferDetailContainer key={item?.toString()}>
					<TransferItem>{item}</TransferItem>
					<TransferData>
						{data}{' '}
						{copy && (
							<Button
								border={colorClick[index] == '#140F33'}
								onClick={() => handleCopyToClipboard(index, value)}
							>
								<CopyIcon strokeColor={colorClick[index] || '#646174'} />
							</Button>
						)}
					</TransferData>
				</TransferDetailContainer>
			))}
		</TransferDetail>
	);
};

export default RefundResume;
